var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"toolbar"},[_c('InputSearch',{staticClass:"search",attrs:{"focus":_vm.shouldFocusSearch,"placeholder":_vm.searchPlaceholder,"value":_vm.searchTerm},on:{"input":function($event){return _vm.handleSearchInput($event, _vm.triggerSearch)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }